import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--trigger-on-click"
export default class extends Controller {
  static values = { urls: Array }
  open(event) {
    event.preventDefault()
    
    this.urlsValue.forEach(v => {
      this.dispatch('valueReceived', { detail: { url: v }})          
    });
  }
}
